import styled from '../../../lib/styled';
import React from 'react';
import { FC } from 'react';
import { colors } from '../../Shared/Style/colors';
import Icon from '../fav-property.svg';

const ThemedProperty = styled(Icon)(() => {
    return {
        height: '24px',
        width: '24px',
        '& g': {
            stroke: colors.icons,
        },
        '& path': {
            stroke: colors.icons,
        },
        '& polyline': {
            stroke: colors.icons,
        },
    };
});
const Property: FC = ({ ...rest }) => {
    return <ThemedProperty {...rest} />;
};

export default Property;
